import { render, staticRenderFns } from "./InstallmentTableV2.vue?vue&type=template&id=24e65504&"
import script from "./InstallmentTableV2.vue?vue&type=script&lang=js&"
export * from "./InstallmentTableV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports